export enum IMQueries {
  IMTable = 'iMTable',
}
